import React from 'react';
import { Scale, CalendarCheck, TrendingDown, BarChart3, Banknote, Eye, Users, Check } from 'lucide-react';
import { useLang } from '../../context/LanguageContext';
import { Reveal, SectionHead } from '../motion';

const TERM_ICONS = [Scale, CalendarCheck, TrendingDown, BarChart3, Banknote, Eye];

export function Terms() {
  const { t } = useLang();
  const terms = t('dcapital.terms');
  return (
    <section id="terms" className="py-24 sm:py-32" data-testid="dc-terms">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHead overline={t('dcapital.termsOverline')} title={t('dcapital.termsTitle')} align="center" />
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {terms.map((item, i) => {
            const Icon = TERM_ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.08} className="h-full">
                <div data-testid={`dc-term-${i}`} className="h-full rounded-xl border border-slate-700/70 bg-[#1E293B] p-7 transition-all duration-300 hover:border-green-500/40 hover:-translate-y-1">
                  <span className="flex w-11 h-11 items-center justify-center rounded-lg bg-green-500/10 border border-green-500/30">
                    <Icon className="w-5 h-5 text-green-400" />
                  </span>
                  <h3 className="mt-5 font-display text-lg text-white">{item.title}</h3>
                  <p className="mt-2.5 text-sm text-slate-400 leading-relaxed">{item.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export function Referral() {
  const { t } = useLang();
  const points = t('dcapital.refPoints');
  return (
    <section id="referral" className="py-24 sm:py-32 bg-[#111D36] border-y border-slate-800" data-testid="dc-referral">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <SectionHead overline={t('dcapital.refOverline')} title={t('dcapital.refTitle')} />
          <Reveal delay={0.12}>
            <p className="mt-6 text-slate-300 leading-relaxed max-w-2xl" data-testid="dc-ref-text">{t('dcapital.refText')}</p>
            <p className="mt-4 text-xs text-slate-500">{t('dcapital.refNote')}</p>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-5">
          <div className="relative rounded-xl border border-amber-400/30 bg-amber-400/5 p-8">
            <div className="absolute -top-4 left-8 inline-flex items-center gap-2 rounded-full bg-amber-400 px-3.5 py-1.5 text-[10px] font-bold tracking-widest text-[#0F172A] uppercase">
              <Users className="w-3 h-3" /> {t('dcapital.stats')[3].v}
            </div>
            <ul className="mt-2 space-y-4">
              {points.map((p, i) => (
                <li key={i} data-testid={`dc-ref-point-${i}`} className="flex items-start gap-3 text-sm text-amber-100/90">
                  <Check className="w-4 h-4 mt-0.5 shrink-0 text-amber-400" />
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
